// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AKXYJ","colBig":"styles_colBig__qKHKs","colSmall":"styles_colSmall__1P7QY","shopifyNameWrapper":"styles_shopifyNameWrapper__2Q784"};